import { Table, TableHeader, TableRow, TableHeading, TableBody, TableCell } from '@insurancemenu/imenu-components-lib';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { getProductLinesFromArray } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import React from 'react';
import { InstalledEnrollmentType } from 'types/enrollmentService';
import { BiGroup } from 'types/groupService';
import { createStyles } from './styles';

export interface PeriodTableProps {
  periods: InstalledEnrollmentType[];
  groups: BiGroup[];
  changeableEffectiveDate?: JSX.Element;
}

const PeriodsModalTable = ({ periods, groups, changeableEffectiveDate }: PeriodTableProps): JSX.Element => {
  const classes = createStyles();

  const rowsList = periods.map((period) => {
    const groupName = groups.find((group) => group.id === period.groupId)?.name || '';
    return (
      <TableRow key={period.id} className={classes.tableRow}>
        <TableCell className={classes.tableCell}>{groupName}</TableCell>
        <TableCell className={classes.tableCell}>
          {changeableEffectiveDate || normDateToShortAmericanDate(period.effectiveDate)}
        </TableCell>
        <TableCell className={classes.tableCell}>{getProductLinesFromArray(period.productLineIds)}</TableCell>
      </TableRow>
    );
  });

  return (
    <div className={classes.tableWrapper}>
      <Table totalElements={periods.length} minHeight="35rem" maxHeight="35rem">
        <TableHeader className={classes.tableHeader}>
          <TableRow>
            <TableHeading className={classes.tableHeading}>Group Name</TableHeading>
            <TableHeading className={classes.tableHeading}>Effective Date</TableHeading>
            <TableHeading className={classes.tableHeading}>Product Lines</TableHeading>
          </TableRow>
        </TableHeader>
        <TableBody className={classes.tableBody}>{rowsList}</TableBody>
      </Table>
    </div>
  );
};

export default PeriodsModalTable;
